
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.859 5.08c.117.057.22.14.3.243a.525.525 0 00-.224.166l-.18.12a.468.468 0 01-.051-.183v-.002l-.002-.014.157-.33zm0 0a.832.832 0 00-.04-.017.502.502 0 00-.117.345l.157-.327zm-17.02.42h16.655a.352.352 0 01.15.032.338.338 0 01.142.13v.001a.337.337 0 01.046.147s0 0 0 0l.001.03v12.493c0 .184-.149.334-.333.334H3.833a.333.333 0 01-.333-.334v-12.5c0-.06.017-.12.046-.17h0c.06-.099.16-.16.293-.163zm16.997.35l.17-.006.017.007c.027.01.158.057.31.017v.425a.5.5 0 01-.484-.37h0a.488.488 0 01-.012-.064h0l-.001-.009zm-.67 1.65v-1l-.8.6-7 5.25a.334.334 0 01-.351.03l-.062-.04L4.968 7.1l-.8-.6V18h16V7.5zM6.334 6.167h-1.5l1.2.9 5.834 4.375.3.225.3-.225L18.3 7.067l1.2-.9H6.333z","fill":"#6F7078","stroke":"#6F7078"}})])
          )
        }
      }
    